export default "__VITE_ASSET__5lCBnhDe__"